import Vue from 'vue'
/** 모달 전체 화면*/
import BaseListScrollPage from '@/components/common/base/BaseListScrollPage'
import BaseDateSelect from '@/components/common/base/BaseDateSelect'
import BaseDatePicker from '@/components/common/base/BaseDatePicker'
import ModalContainer from '@/components/modalContainer'
import ModalAlertContainer from '@/components/modalAlertContainer'

/** 모달 ALERT*/
import ModalAlert from '@/components/common/alert/Alert'
import ModalConfirm from '@/components/common/alert/Confirm'
import ModalMainPopup from '@/components/common/alert/main-popup'
import ModalDaumPostCode from '@/components/common/alert/daum-post-code'
import ModalEduApplyPopup from '@/components/common/alert/edu-apply-popup'
import ModalEduCancelPopup from '@/components/common/alert/edu-cancel-popup'
import ModalEduApplicationPopup from '@/components/common/alert/edu-application-popup'
import ModalExamInfoPopup from '@/components/common/alert/exam-info-popup'
import ModalExamCertPopup from '@/components/common/alert/exam-cert-popup'
import ModalExamAdmissionPopup from '@/components/common/alert/exam-admission-popup'
import ModalExamCertificationReapplyPopup from '@/components/common/alert/exam-certification-reapply-popup'
import ModalFindIdResult from '@/components/common/alert/find-id-result'
import ModalInfoPrivacyPolicy from '@/components/common/alert/info-privacy-policy'
import ModalInfoTerms from '@/components/common/alert/info-terms'
import ModalMarketing from '@/components/common/alert/info-marketing'

import Datepicker from 'vuejs-datepicker'
import CustomDatepicker from '@/components/common/datepicker/custom-datepicker'
import Pagination from '@/components/pages/common/pagination'

import ModalCommonConfirmInfo from '@/components/common/alert/common-confirm-info'
import ModalChangeUserInactive from '@/components/common/alert/change-user-status-inactive'

const modalNames = {}

const modalAlertNames = {
  ALERT: ModalAlert.name,
  CONFIRM: ModalConfirm.name,
  MODAL_MAIN_POPUP: ModalMainPopup.name,
  MODAL_DAUM_POST_CODE: ModalDaumPostCode.name,
  MODAL_EDU_APPLY_POPUP: ModalEduApplyPopup.name,
  MODAL_EDU_CANCEL_POPUP: ModalEduCancelPopup.name,
  MODAL_EDU_APPLICATION_POPUP: ModalEduApplicationPopup.name,
  MODAL_EXAM_INFO_POPUP: ModalExamInfoPopup.name,
  MODAL_EXAM_CERT_POPUP: ModalExamCertPopup.name,
  MODAL_EXAM_ADMISSION_POPUP: ModalExamAdmissionPopup.name,
  MODAL_EXAM_CERTIFICATION_REAPPLY_POPUP:
    ModalExamCertificationReapplyPopup.name,
  MODAL_FIND_ID_RESULT: ModalFindIdResult.name,
  MODAL_INFO_PRIVACY_POLICY: ModalInfoPrivacyPolicy.name,
  MODAL_INFO_TERMS: ModalInfoTerms.name,
  MODAL_MARKETING: ModalMarketing.name,
  
  MODAL_COMMON_CONFIRM_INFO: ModalCommonConfirmInfo.name,
  MODAL_CHANGE_USER_INACTIVE: ModalChangeUserInactive.name
}

Vue.prototype.$modalNames = modalNames
Vue.prototype.$modalAlertNames = modalAlertNames

Vue.component(BaseListScrollPage.name, BaseListScrollPage)
Vue.component(BaseDateSelect.name, BaseDateSelect)
Vue.component(BaseDatePicker.name, BaseDatePicker)
Vue.component(ModalContainer.name, ModalContainer)

/** 모달 ALERT */

Vue.component(ModalAlertContainer.name, ModalAlertContainer)
Vue.component(ModalAlert.name, ModalAlert)
Vue.component(ModalConfirm.name, ModalConfirm)
Vue.component(ModalMainPopup.name, ModalMainPopup)
Vue.component(ModalDaumPostCode.name, ModalDaumPostCode)
Vue.component(ModalEduApplyPopup.name, ModalEduApplyPopup)
Vue.component(ModalEduCancelPopup.name, ModalEduCancelPopup)
Vue.component(ModalEduApplicationPopup.name, ModalEduApplicationPopup)
Vue.component(ModalExamInfoPopup.name, ModalExamInfoPopup)
Vue.component(ModalExamCertPopup.name, ModalExamCertPopup)
Vue.component(ModalExamAdmissionPopup.name, ModalExamAdmissionPopup)
Vue.component(
  ModalExamCertificationReapplyPopup.name,
  ModalExamCertificationReapplyPopup
)
Vue.component(ModalFindIdResult.name, ModalFindIdResult)
Vue.component(ModalInfoPrivacyPolicy.name, ModalInfoPrivacyPolicy)
Vue.component(ModalInfoTerms.name, ModalInfoTerms)
Vue.component(ModalMarketing.name, ModalMarketing)
Vue.component('datepicker', Datepicker)
Vue.component(CustomDatepicker.name, CustomDatepicker)
Vue.component(Pagination.name, Pagination)
Vue.component(ModalCommonConfirmInfo.name, ModalCommonConfirmInfo)
Vue.component(ModalChangeUserInactive.name, ModalChangeUserInactive)